import { inject } from '@angular/core'
import { CustomerService } from '../../../services/customer/customer.service'

export const userTypeResolver = () => {
  const customerService = inject(CustomerService)
  return customerService.userType$
}
